import script from "./InviteDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./InviteDialog.vue?vue&type=script&setup=true&lang=js"

import "./InviteDialog.vue?vue&type=style&index=0&id=72e02ee8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72e02ee8"]])

export default __exports__